import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { ToggleElement, SocialLink } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { colors, typography } from '../styles';
import HeaderMenu from './HeaderMenu';
import ContactModal from './ContactModal';
import Search from './Search';

const styles = css`
  height:60px;
  position:relative;
  @media (min-width: 1199px) {
    height: 100px;
  }

  .Header_Wrapper {
    height: 60px;
    position: fixed;
    width: 100%;
    background-color: #FFFFFF;
    z-index: 50;
    @media (min-width: 1199px) {
      height: 100px;
    }
  }
  .Header_logo {
    display: block;
    width: auto;
    height: 60px;
    position: absolute;
    top: 0;
    left: 0;
    background: ${colors.color2};
    padding:10px;
    @media (min-width: 1199px) {
      height: 160px;
      padding:26px;
    }
    img {
      height: 100%;
    }
  }
  .socialWrapper {
    display: inline-block;
    position: absolute;
    left: 105px;
    top: 17px;
    @media (min-width: 1199px) {
      left: 265px;
      top: 35px;
    }
    ul {
      padding-inline-start: 0;
      list-style-type: none;
      li {
        display: inline-block;
        margin: 0 10px;
        @media (min-width: 1199px) {
          margin: 0 0 0 15px;
        }
      }
    }
  }
  .Header_search {
    position: absolute;
    right: 60px;
    top: 0;
    z-index: 2;
    border-left:1px solid #eee;
    height: 59px;
    @media (min-width: 1199px) {
      right: 0;
      top: 0;
      height: 99px;
    }
  }
  .Header_search span {
    content: " ";
    display: block;
    width: 50px;
    height: 60px;
    border: 0;
    background-image: url('/images/icon-search.svg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto 24px;
    @media (min-width: 1199px) {
      height: 100px;
      width: 100px;
    }
    &:focus {
      background-color: ${colors.color1};
      background-image: url('/images/icon-search-white.svg');
      outline: 0;
      box-shadow: 0;
    }
  }
  .Header_searchResults {
    width: 100%;
    background-color: ${colors.color1};
    position: fixed;
    top: 60px;
    left: 0;
    padding: 20px;
    @media (min-width: 1199px) {
      right: 0;
      top: 100px;
      left: auto;
      padding: 20px;
    }
    h3 {
      font-size: 20px;
      color: #FFFFFF;
      margin: 0 0 15px 0;
      font-family: ${typography.Display};
      @media (min-width: 1199px) {
        font-size: 28px;
      }
    }
    input {
      width: 100%;
      padding: 4px 8px;
    }
    .results {
      list-style: none;
      margin: 10px 0 0 0;
      padding: 10px 0;
      height: 200px;
      overflow-y: scroll;
      background-color: #FFFFFF;
      a {
        display: block;
        padding: 10px 10px;
        font-size: 15px;
        line-height: 1.1;
        font-weight: 700;
        &:hover {
          background-color: #EFEFEF;
        }
      }
    }
  }
  .Header_menuToggle {
    width: 60px;
    height: 60px;
    border: 0;
    background-color: ${colors.color3};
    position: absolute;
    right: 0;
    top: 0;
    background-image: url('/images/icon-menu.svg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 30px 20px;
    padding: 0;
    margin: 0;
    @media (min-width: 1199px) {
      display: none;
    }
  }
  .OSCTag_wrapper {
    display: none;
    @media (min-width: 1199px) {
      display: block;
      position: fixed;
      right: 0;
      top: 100px;
      background-color: ${colors.color2};
      cursor: pointer;
      z-index: 1;
    }
  }
  .OSCTag_image {
    display: none;
    width: 70px;
    height: 70px;
    float: left;
    background-color: #eeeeee;
  }
  .OSCTag_content {
    float: left;
    padding: 10px 20px;
  }
  .OSCTag_headline {
    color: #FFFFFF;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 1;
    margin: 0 0 5px 0;
  }
  .OSCTag_phone {
    color: #FFFFFF;
    line-height: 1;
  }
`;

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuActive: false,
    };
  }

  toggleMenu = () => {
    this.setState({
      menuActive: !this.state.menuActive,
    });
  }

  render() {
    const { builder } = this.props;
    const { menuActive } = this.state;
    return (
      <div className={styles}>
        <div className="Header_Wrapper">
          <Link className="Header_logo" name="index">
            <img src="/images/logo-ko.svg" alt={builder.name} />
          </Link>
          <div className="socialWrapper">
            <ul className="Header_socialLinks">
              {
                builder.socialLinks.map(link => (
                  <li key={link}>
                    <SocialLink
                      url={link}
                    />
                  </li>
                ))
              }
            </ul>
          </div>
          <button className="Header_menuToggle" onClick={this.toggleMenu} />
          <HeaderMenu isActive={menuActive} toggleMenu={this.toggleMenu} builder={builder} />
          <div className="Header_search">
            <ToggleElement
              className="Header_searchButton"
            >
              <Search className="Header_searchResults" />
            </ToggleElement>
          </div>
          <ContactModal builder={builder}>
            <div className="OSCTag_wrapper">
              <div className="OSCTag_image" />
              <div className="OSCTag_content">
                <div className="OSCTag_headline">
                  Ask {builder.name}!
                </div>
                <div className="OSCTag_phone">
                  {builder.telephone}
                </div>
              </div>
            </div>
          </ContactModal>
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  builder: PropTypes.object.isRequired,
};

export default withData(
  {
    builder: true,
  },
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js